import { Badge } from "../../../../components/ui/common/badge";
import { TableCell, TableRow } from "../../../../components/ui/common/table";
import { SupplierRow } from "../types/supplierListView.types";
import { supplierTableColumnClass } from "./supplierTable.columns";
import SupplierRowActions from "./SupplierRowActions";

interface SupplierTableRowProps {
  row: SupplierRow;
  countryNameById: Map<number, string>;
  onView: (row: SupplierRow) => void;
  onEdit: (row: SupplierRow) => void;
  onDelete: (row: SupplierRow) => void;
}

/** One supplier's row — mirrors the prototype's `LcaSuppliers.tsx` row markup exactly. */
const SupplierTableRow = ({ row, countryNameById, onView, onEdit, onDelete }: SupplierTableRowProps) => {
  const countryName = row.supplier_country ? countryNameById.get(row.supplier_country) : undefined;
  const subtext = [countryName || "—", row.supplier_province].filter(Boolean).join(" · ");

  return (
    <TableRow className="tw-bg-white hover:tw-bg-muted/50">
      <TableCell className={supplierTableColumnClass.name}>
        <div className="tw-text-sm tw-font-medium tw-text-foreground">{row.supplier_name}</div>
        <div className="tw-mt-0.5 tw-font-mono tw-text-[11px] tw-text-muted-foreground">{subtext}</div>
      </TableCell>
      <TableCell className={supplierTableColumnClass.contactName}>
        <div className="tw-flex tw-items-center tw-gap-2">
          <span className="tw-text-sm tw-text-foreground">{row.supplier_contact_name || "—"}</span>
          {row.is_supplier_as_user ? (
            <Badge variant="outline" className="tw-text-[10px] tw-font-normal">
              User
            </Badge>
          ) : null}
        </div>
      </TableCell>
      <TableCell className={`${supplierTableColumnClass.email} tw-text-sm tw-text-foreground`}>
        {row.supplier_email || "—"}
      </TableCell>
      <TableCell className={`${supplierTableColumnClass.phone} tw-font-mono tw-text-sm tw-text-foreground`}>
        {row.supplier_phone || "—"}
      </TableCell>
      <TableCell className={supplierTableColumnClass.actions}>
        <SupplierRowActions row={row} onView={onView} onEdit={onEdit} onDelete={onDelete} />
      </TableCell>
    </TableRow>
  );
};

export default SupplierTableRow;
